<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
        <span>
            <span>{{ title }}</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>

</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> عنوان کالا : </span>
                    <span *ngIf="lang == 2"> Material Name : </span>
                    <input class='wh-input' formControlName="title" autocomplete="off" [required]="required()">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class=' wh-label'>
                    <span *ngIf="lang == 1"> انتخاب انبار: </span>
                    <span *ngIf="lang == 2"> Place : </span>
                    <span (click)="reset_input(219)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">
                            close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="place_title" (click)="load_services(219) " readonly>
                    <input class="wh-input" formControlName="place" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class=' wh-label'>
                    <span *ngIf="lang == 1"> واحد وزنی : </span>
                    <span *ngIf="lang == 2"> Cate : </span>
                    <span (click)="reset_input(218)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">
                            close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="weight_title" (click)="load_services(218) " readonly>
                    <input class="wh-input" formControlName="weight" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> موجودی اول دوره : </span>
                    <span *ngIf="lang == 2"> Material Name : </span>
                    <input class='wh-input' formControlName="inventory" autocomplete="off" [required]="required()">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> قیمت واحد به تومان : </span>
                    <span *ngIf="lang == 2"> Material Name : </span>
                    <input class='wh-input' formControlName="price" autocomplete="off" [required]="required()"
                        currencyMask>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب پرت: </span>
                    <input class='wh-input' formControlName="pert" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب نصب: </span>
                    <input class='wh-input' formControlName="nasb" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب سود: </span>
                    <input class='wh-input' formControlName="sod" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="haml" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب حمل داخلی: </span>
                    <input class='wh-input' formControlName="haml" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="haml2" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب حمل خارجی: </span>
                    <input class='wh-input' formControlName="haml2" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="convert" class='wh-label'>
                    <span *ngIf="lang == 1"> تبدیل: </span>
                    <input class='wh-input' formControlName="convert" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" autocomplete="off">
                </label>
            </div>

        </div><!-- -->
        <!-- *********************************************************************************************************** -->
        <app-wharehouse-material-cate3 [obj]="obj" *ngIf="type_task == 2"></app-wharehouse-material-cate3>
        <!-- *********************************************************************************************************** -->


        <div class="row">

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> توضیحات : </span>
                    <span *ngIf="lang == 2"> Comment : </span>
                    <textarea style="height: 5rem;" class="wh-input" formControlName="comment">
                    </textarea>
                </label>
            </div>

            <div *ngIf="type_task == 2">
                <div class='col-md-4 col-lg-4 col-sm-4 col-xs-12 pe' [ngClass]="{en:lang==2}"
                    style="padding-top:0.5rem">
                    <span>لوگو</span>
                    <mat-card class="example-card logo cursor backgroundImage"
                        style="padding:3px 16px 7px 16px;width:100%;height:10rem"
                        [ngStyle]="{'background-image':'url( ' + logo + ')'}" (click)="logo1.click()" accept="image/*">
                        <mat-card-header style="display:inline" class="pe1" [ngClass]="{en1:lang==2}">
                        </mat-card-header>
                    </mat-card>
                    <span (click)="delete_logo()" *ngIf="logo_bin == true"><i class="far fa-trash-alt icon"
                            style="margin: 0px 4px;"></i></span>
                    <input type="file" (change)="change_logo($event)" style="display: none;" #logo1>
                </div><!-- col-md-4 col-lg-4 col-sm-4 col-xs-12 pe  -->


                <div class='col-md-4 col-lg-4 col-sm-4 col-xs-12 pe' [ngClass]="{en:lang==2}"
                    style="padding-top:0.5rem">
                    <span>Finishing</span>
                    <mat-card class="example-card logo cursor backgroundImage"
                        style="padding:3px 16px 7px 16px;width:100%;height:10rem"
                        [ngStyle]="{'background-image':'url( ' + logo2 + ')'}" (click)="logos2.click()"
                        accept="image/*">
                        <mat-card-header style="display:inline" class="pe1" [ngClass]="{en1:lang==2}">
                        </mat-card-header>
                    </mat-card>
                    <span (click)="delete_logo2()" *ngIf="logo2_bin == true"><i class="far fa-trash-alt icon"
                            style="margin: 0px 4px;"></i></span>
                    <input type="file" (change)="change_logo2($event)" style="display: none;" #logos2>
                </div><!-- col-md-4 col-lg-4 col-sm-4 col-xs-12 pe  -->

            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>